import { GeekItemForLeaderboard, GeekItem } from '@/models';
import { Season, GeekProfileGeneralScore } from '@/models/geek-profile';
import { typedStore, Actions } from '@/store';
import debounce from 'lodash.debounce';
import Vue from 'vue';

export const leaderboardMixin = Vue.extend({
  data() {
    return {
      activeSeason: {
        start: '',
        end: '',
        id: '',
        isOngoing: false,
        isGlobal: false,
        name: '',
      } as Season,
      filters: {
        debounce: {
          searchPhrase: '',
        },
      },
      loader: {
        isLeaderboardPending: false,
        isGeekDetailsPending: false,
      },
      publicPath: process.env.BASE_URL,
      activeGeek: {} as GeekItemForLeaderboard,
    };
  },
  computed: {
    currentSeason(): Season {
      return typedStore(this).state.seasons.currentSeason;
    },
    seasons(): Season[] {
      return typedStore(this).state.seasons.seasons;
    },
    geeks(): GeekItemForLeaderboard[] {
      return typedStore(this).state.scores.leaderboard;
    },
    currentGeek(): GeekItem {
      return typedStore(this).state.geek.geek;
    },
    generalScore(): GeekProfileGeneralScore {
      return typedStore(this).state.scores.generalScore;
    },
    areMoreItemsAvailable(): boolean {
      return this.geeks.length < typedStore(this).state.scores.pagination.totalCount && this.geeks.length > 0;
    },
    isCurrentGeek(): boolean {
      return this.activeGeek.id === typedStore(this).state.geek.current.id;
    },
  },
  methods: {
    async setSeason(season: Season) {
      this.$router.push({name: 'leaderboard', query: {seasonId: season.id}});
      this.loadLeaderboard();
    },
    setActiveGeek() {
      throw new Error('Method not implemented');
    },
    loadLeaderboard() {
      throw new Error('Method not implemented');
    },
    async loadMoreElements(this: any) {
      this.loader.isLeaderboardPending = true;
      try {
        await this.$store.dispatch(
          Actions.scores.fetchMoreLeaderboard,
          { ...this.filters.debounce, ...this.filters.immediate, seasonId: this.activeSeason.id },
        );
      } finally {
      this.loader.isLeaderboardPending = false;
      }
    },
    async fetchLeaderborad(this: any) {
      this.loader.isLeaderboardPending = true;
      await this.$store.dispatch(
        Actions.scores.fetchLeaderboard,
        { ...this.filters.debounce, ...this.filters.immediate, seasonId: this.activeSeason.id },
      );
      this.loader.isLeaderboardPending = false;
    },
  },
  watch: {
    'filters.debounce': {
      handler: debounce(async function(this: any) {
        this.fetchLeaderborad();
      }, 1000),
      deep: true,
    },
    'filters.immediate': {
      handler(this: any) {
        this.fetchLeaderborad();
      },
      deep: true,
    },
  },
});
